export function camelToKebab(name: string): string {
  return name.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
}

export function kebabToCamel(name: string): string {
  return name.replace(/-([a-z])/g, (_, letter: string) => letter.toUpperCase());
}

export function tagNameFor(name: string): string {
  const camel = name.charAt(0).toLowerCase() + name.slice(1);

  return `rwc-${camelToKebab(camel)}`;
}
